/**
 * Created by PuTi(编程即菩提) 10/21/17.
 */
var nb = require("../../../nb");
var toast = require("../../../toast");
var inputGroup = require("../../../model/form/InputWithLabel");
var login = require("../../../io/" + process.env.APP_ENV + "/login/Login");
var syncUserData = require("../../../io/" +
  process.env.APP_ENV +
  "/login/syncUserData");
var syncUserContactData = require("../../../io/" +
  process.env.APP_ENV +
  "/login/syncUserContactData");
var syncUserPriceData = require("../../../io/" +
  process.env.APP_ENV +
  "/login/syncUserPriceData");
var syncUserAddressData = require("../../../io/" +
  process.env.APP_ENV +
  "/login/syncUserAddressData");

var idNum, password, button;
module.exports = nb.define({
  parent: nb.Model,
  mapping: {
    idNum: inputGroup,
    password: inputGroup,
    button: nb.Model,
  },
  method: {
    init: function () {
      idNum = this.get("idNum");
      password = this.get("password");
      button = this.get("button");
      button.set("disabled", ""); //按钮点击
      this.onChange(
        "submitLogin",
        function (inEvent) {
          //点击登录
          this.checkModel(); //验证
        },
        this
      );
      idNum.onChange("blur", function () {
        idNum._checkInputEmpty(idNum); // _checkIsEmailAndMobile
      });
      password.onChange("blur", function () {
        idNum._checkPassword(password);
      });
    },
    checkModel: function () {
      if (idNum._checkInputEmpty(idNum)) {
        //  _checkIsEmailAndMobile
        return;
      }
      if (password._checkPassword(password)) {
        return;
      }
      this._login();
    },
    loginReady: function (inResp) {
      var token = inResp.token; //token
      var userName = inResp.nickName || inResp.loginName; // 登录名 nickName loginName
      var userId = inResp.userId; //用户ID
      var companyId = inResp.companyId; //公司ID
      var companyType = inResp.companyType; //公司类型
      var state = inResp.status; //待补充 企业信息状态   state
      var onlyWater = inResp.onlyWater || false;

      //有／无企业信息
      // var userState = $.cookie('company-info-status') || 1;  //todo 企业信息是否填写
      $.cookie("asc_b2b_onlyWater", onlyWater);
      $.cookie("asc_b2b_userName", userName); //用户名
      $.cookie("asc_b2b_companyId", companyId); //公司ID
      $.cookie("asc_b2b_companyType", companyType); //公司类型
      $.cookie("asc_b2b_userType", inResp.innerUser); //用户类型 内部用户（1：是；0：不是）
      $.cookie("asc_b2b_userId", userId); //userId
      $.cookie("asc_b2b_token", token); //唯一标示
      $.cookie("asc_b2b_userState", state); //有无企业信息

      if (state == "1") {
        //无企业信息填写提示 1

        var dialog = require("../../../model/modal/CompleteInformation");
        dialog.set("show", true);
      } else {
        var userModel = require("../../../model/User");
        userModel.set("token", token);
        toast.setOpts({
          text: nb.model.get("prompt").loginSuccessText, //登录成功！
          status: "success",
        });
        setTimeout(function (args) {
          if (onlyWater) {
            window.location.href = "inquiryList.html";
          } else {
            window.location.href = "index.html";
          }
        }, 1000);
      }
    },
    _login: function () {
      button.set("disabled", "disabled"); //按钮禁止
      login({
        data: {
          phone: idNum.get("value"),
          pwd: password.get("value"),
        },
        scope: this,
        success: function (inResp) {
          var userId = inResp.userId;
          if (!inResp.isSyncData) {
            nb.model.set("syncText", "正在同步用户数据...");
            nb.model.set("syncDataVisible", "visible");
            syncUserData({
              data: {
                userId: userId,
              },
              scope: this,
              success: function () {
                toast.setOpts({
                  text: "同步用户数据成功",
                  status: "success",
                });
              },
              always: function () {
                nb.model.set("syncText", "正在同步用户联系人数据...");
                syncUserContactData({
                  data: {
                    userId: userId,
                  },
                  scope: this,
                  success: function () {
                    toast.setOpts({
                      text: "同步用户联系人数据成功",
                      status: "success",
                    });
                  },
                  always: function () {
                    nb.model.set("syncText", "正在同步用户地址数据...");
                    syncUserAddressData({
                      data: {
                        userId: userId,
                      },
                      scope: this,
                      success: function () {
                        toast.setOpts({
                          text: "同步用户地址数据成功",
                          status: "success",
                        });
                      },
                      always: function () {
                        nb.model.set("syncText", "正在同步用户价格数据...");
                        syncUserPriceData({
                          data: {
                            userId: userId,
                          },
                          scope: this,
                          success: function () {
                            toast.setOpts({
                              text: "同步用户价格数据成功",
                              status: "success",
                            });
                          },
                          always: function () {
                            nb.model.set("syncText", "同步完成");
                            this.loginReady(inResp);
                          },
                        });
                      },
                    });
                  },
                });
              },
            });
          } else {
            this.loginReady(inResp);
          }
        },
        error: function (inResp) {
          var error = inResp.error;
          var code = error.code;
          var info = error.info;
          switch (code) {
            case 1:
              idNum._setErrorInfo(idNum, info);
              password._setErrorInfo(password, info);
              break;
            case 2:
              break;
            default:
              toast.setOpts({
                text: nb.model.get("prompt").loginFailText, //登录失败，请稍后再试！
              });
              break;
          }
        },
        always: function () {
          button.set("disabled", ""); //按钮禁止
        },
      });
    },
  },
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/login/model/Form.js
// module id = 162
// module chunks = 6 32